import React from 'react';
import { Alert as AlertNew, AlertModal as AlertModalNew } from './AlertModal';
import { convertOldAlertModalProps, convertOldAlertProps } from './converter.old';
import type { OldAlertModalProps } from './converter.old';

export type AlertModalProps = OldAlertModalProps;

export const AlertModal = (props: AlertModalProps) => <AlertModalNew {...convertOldAlertModalProps(props)} />;
export const Alert = (props: AlertModalProps) => AlertNew(convertOldAlertProps(props));
